/* eslint-disable no-unused-vars */
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  AccessibilityHelp,
  Autoformat,
  Autosave,
  BlockQuote,
  Bold,
  ClassicEditor,
  Clipboard,
  Code,
  CodeBlock,
  Essentials,
  FindAndReplace,
  Font,
  FontFamily,
  Heading,
  Highlight,
  HorizontalLine,
  Indent,
  IndentBlock,
  Italic,
  List,
  Mention,
  PageBreak,
  Paragraph,
  PasteFromOffice,
  SpecialCharacters,
  SpecialCharactersEssentials,
  Strikethrough,
  Subscript,
  Superscript,
  Table,
  TableCaption,
  TableColumnResize,
  TableToolbar,
  TextTransformation,
  Underline,
  Undo,
  WordCount,
  Alignment,
  GeneralHtmlSupport,
} from "ckeditor5";

import "ckeditor5/ckeditor5.css";

const Editor = ({ editorsData = "", handleEditor, readOnly = false }) => {
  return (
    <CKEditor
      editor={ClassicEditor}
      config={{
        toolbar: {
          items: [
            "undo",
            "redo",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "|",
            "code",
            "subscript",
            "superscript",
            "heading",
            "outdent",
            "indent",
            "|",
            "bulletedList",
            "numberedList",
            "|",
            "blockQuote",
            "codeBlock",
            "findAndReplace",
            "fontSize",
            "fontFamily",
            "fontColor",
            "fontBackgroundColor",
            "fontFamily",
            "highlight",
            "horizontalLine",
            "pageBreak",
            "specialCharacters",
            "insertTable",
            "toggleTableCaption",
            "alignment",
          ],
        },
        plugins: [
          GeneralHtmlSupport,
          Bold,
          Essentials,
          Italic,
          Mention,
          Paragraph,
          Undo,
          AccessibilityHelp,
          Autoformat,
          TextTransformation,
          List,
          Autosave,
          Code,
          Strikethrough,
          Subscript,
          Superscript,
          Underline,
          Indent,
          IndentBlock,
          BlockQuote,
          CodeBlock,
          Clipboard,
          FindAndReplace,
          Font,
          FontFamily,
          Heading,
          Highlight,
          HorizontalLine,
          PageBreak,
          WordCount,
          PasteFromOffice,
          SpecialCharacters,
          SpecialCharactersEssentials,
          Table,
          TableToolbar,
          TableColumnResize,
          TableCaption,
          Alignment,
        ],
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true,
            },
          ],
        },

        placeholder: "Type the content here!",
      }}
      data={editorsData}
      onChange={(_event, editor) => {
        const data = editor.getData();
        handleEditor && handleEditor(data);
      }}
      disabled={readOnly}
    />
  );
};

export default Editor;
